import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Rubric } from 'src/app/classes/news';
import { NewsService } from 'src/app/services/news.service';
import { accordeonMe } from 'src/app/animations';


@Component({
	selector: 'app-rubric-management',
	templateUrl: './rubric-management.component.html',
	styleUrls: [ '../management-interface.css', '../accordeon-ui.scss' ],
	animations: [ accordeonMe ],
})
export class RubricManagementComponent implements OnInit, OnDestroy {


	elements: Rubric[] = [];
	currentFilter = "";
	filteredElements: Rubric[] = [];
	expandedElementId = "";

	sortingField = 'name';
	sortingAsc = true;


	bLoading = true;
	subscriptions = new Subscription();


	constructor(
		private matDialog: MatDialog,
		private newsService: NewsService
	) {}


	ngOnInit() {

		this.refreshList();

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	private refreshList() {

		this.newsService.getRubrics().subscribe( rubrics => {

			this.elements = rubrics;
			this.sortElements();
			this.bLoading = false;

		});

	}

	sortColumn( field: string ) {

		if( this.sortingField === field ) {
			this.sortingAsc = !this.sortingAsc;
		} else {
			this.sortingField = field;
			this.sortingAsc = true;
		}

		this.sortElements();

	}

	sortElements() {

		this.elements.sort( ( a, b ) => {

			const valueA = (a.name || '').toString();
			const valueB = (b.name || '').toString();
		
			return this.sortingAsc ? valueA.localeCompare( valueB ) : valueB.localeCompare( valueA );

		});

		this.applyFilter();

	}

	clickOnRow( elementId: string ) {

		const bPrevious = !!this.expandedElementId;

		this.expandedElementId = ( this.expandedElementId == elementId ) ? "" : elementId;

		if( bPrevious && this.expandedElementId ) {
			setTimeout( () => {
				const elem = window.document.getElementById( "elementRow_" + elementId );
				if( elem ) {
					elem.scrollIntoView( { behavior: "smooth", block: "start" } );
				}
			}, 500 );
		}

	}

	onFilterChanged( event: Event ) {

		this.currentFilter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase(); 
		this.applyFilter();

	}

	private applyFilter() {

		this.filteredElements = this.elements.filter( u => {

			if( !u.name ) return false;
			const str = ("" + u.name).toLowerCase();
			if( str.includes( this.currentFilter ) ) return true;

			return false;

		});

	}
	showCreationDialog() {

		this.matDialog.open( RubricCreatorDialog, {
			maxHeight: '90vh', 
		}).afterClosed().subscribe( () => {
			this.refreshList();
		});

	}

	onRubricDeleted( rubric: Rubric ) {

		const i = this.elements.findIndex( r => r.id === rubric.id );
		if( i == -1 ) return;

		this.elements.splice( i, 1 );
		this.sortElements();

	}

}



@Component( {
	selector: 'rubric-creator-dialog',
	template: `<app-rubric-editor (done)="creationDone()" />`
})
export class RubricCreatorDialog {

	constructor(
		public dialogRef: MatDialogRef<RubricCreatorDialog>,
	) {}

	creationDone() {
		this.dialogRef.close();
	}
}
